import React, { useRef } from "react";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import useCommonServices from "../../hooks/useCommonServices";
import { submitEnclosureFiles } from "../auth/services/privateapicalling";
import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
import { toast } from "react-toastify";

interface ApplicationDetails {
  traderName: string;
  applicantType: string;
  registeredWithAPMC: string;
  licensePeriod: string;
  licenseFee: string;
  paymentStatus: string;
  applicationStatus: string;
}

interface StatusOption {
  value: string;
  label: string;
}

const status: StatusOption[] = [
  { value: "open", label: "Open" },
  { value: "closed", label: "Closed" },
  { value: "pending", label: "Pending" },
];

interface FormData {
  parameterIssue: StatusOption;
  remark: string;
  status: StatusOption;
}

interface AddressData {
  address: string;
  post: string;
  taluka: string;
  district: string;
}
interface UserAddress {
  address: string;
  post: string;
  taluka: string;
  district: string;
}

interface OfficeAddress {
  address: string;
  post: string;
  taluka: string;
  district: string;
}

interface OfficeDetails {
  panCardNo: string;
  electionCardNo: string;
  registeredEmail: string;
  mobileNo: string;
}
interface Representative {
  id: number;
  name: string;
  age: number;
  address: string;
}
interface Director {
  id: number;
  name: string;
  age: number;
  address: string;
}

interface unsignedProps {
  applicationId: string;
  setLicense?: (value: boolean) => void;
}

declare global {
  interface Window {
    bootstrap: any;
  }
}

const ApproveUnsigned: React.FC<unsignedProps> = ({ applicationId,setLicense }) => {
  const { downloadLicense } = useCommonServices();
    const token = useSelector((state: any) => state.auth.token);
  
  const language = useSelector((state: any) => state.auth.language);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [signedDocUploaded , setSignedDocUploaded] = useState<boolean>(false);
  const navigate = useNavigate();

  const [approvalStatus, setApprovalStatus] = useState("Approved Unsigned");

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [licenseUploaded , setLicenseUploaded] = useState(false);
  const [isModalClose , setIsModalClose] = useState(false)

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]); // Store the selected file
    }
  };
   const buttonRef = useRef(null);
   const closeBtnRef = useRef<HTMLButtonElement>(null);


  const handleDownload = async () => {
    try {
      const licenseRes = await downloadLicense(applicationId);
      //.log("licenseRes", licenseRes);

      const url = window.URL.createObjectURL(licenseRes);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `license-${applicationId}.pdf`); // Suggested file name
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      //.log("error", error);
    }
  };

  const handleUploadSingnedDoc = async()=>{
    setLicenseUploaded(true);

    try {
      // if(!selectedFile)
      //   alert("please upload file")

    const formData = new FormData();
    //.log('file',selectedFile)
    formData.append("file", selectedFile as Blob);
    formData.append("documentName", "license");
    formData.append("applicationId", applicationId);

    const res = await submitEnclosureFiles(formData , token);
    setLicenseUploaded(false);

    //.log('ress', res);
    if(res.success==true)
    { setLicense(true)
      setSelectedFile(null)
      setSignedDocUploaded(true)
      // alert(`${res.message}`)
      // const modalInstance =
      //   window.bootstrap.Modal.getInstance(modalRef.current) ||
      //   new window.bootstrap.Modal(modalRef.current);
      // modalInstance.hide();
       closeBtnRef.current?.click();


     
    }
    else{
      toast.error(`${res.message}`)

    }

    } catch (error) {
      //.log('error' ,error)
    }
  }

  useEffect(() => {
    const getApplicationDetails = async () => {
      try {
        // const data = await fetchApplicationDetails(); // Fetch application details from API
        // setApplication(data);
      } catch (err) {
        setError("Failed to load application details");
      } finally {
        setLoading(false);
      }
    };

    getApplicationDetails();
  }, []);

  useEffect(()=>{
  
     if(signedDocUploaded)
    
     {

      setIsModalClose(true)
      setTimeout(()=>{
      navigate('/approval');

      },200)

     }

  },[signedDocUploaded])

  return (
    <div>
      <div className="mt-2">
        <div className="">
          {approvalStatus === "Approved Unsigned" && (
            <div className="">
              <div className="col-xl-12">
                <div className="card p-4">
                  <div className="">
                    <h4 className="card-title text-success">
                      {language.approvedunsigned_h1}
                    </h4>
                  </div>
                  <div className="card-body ">
                    <div className="text-info">
                      {" "}
                      <h4 className="mb-2">{language.approvedunsigned_h2}</h4>
                      <p>1. {language.approvedunsigned_s1}</p>
                      <p>2. {language.approvedunsigned_s2}</p>
                      <p>3. {language.approvedunsigned_s3}</p>
                    </div>
                    <div className=" d-flex align-items-center gap-4 mt-4">
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={handleDownload}
                      >
                        1. {language.dul}
                      </button>
                      <Link
                        to="#"
                        className="btn  btn-info btn-sm"
                        data-bs-toggle="modal"
                        data-inert={true}
                        data-bs-target="#upload-sealed-license"
                      >
                        2. {language.usl}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="modal fade" id="upload-sealed-license" >
        <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content ">
        {/* {licenseUploaded && (
          <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-75" style={{zIndex: 9999}}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )} */}
            <div className="modal-header">
              <h4 className="modal-title">{language.usl}</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">{language.upf}</label>
                      <input
                        type="file"
                        className="form-control"
                        accept="application/pdf"
                        onChange={handleFileUpload}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  {language.can}
                </button>
                <button
                  type="button"
                  ref={buttonRef}
                  disabled={licenseUploaded}
                  className="btn btn-primary"
                  // data-bs-dismiss="modal"
                  onClick={handleUploadSingnedDoc}
                   {...(isModalClose ? { "data-bs-dismiss" : "modal" } : {})}
                >
                  { licenseUploaded ?  <i className="ion-load-a ion-spin"></i>  : language.upload}
                </button>
                <button
                    type="button"
                    ref={closeBtnRef}
                    data-bs-dismiss="modal"
                    className="d-none"
                  >

                  </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApproveUnsigned;
